/**
 * Un istante del server, riportato sull'orologio di CHI GUARDA.
 *
 * `istante` e `serverTime` sono stati letti nello stesso momento lato server,
 * quindi la loro differenza e' la durata vera: sommandola a `Date.now()` si
 * ottiene lo stesso momento espresso nell'orologio locale, anche su un
 * telefono con l'ora sbagliata. Confrontare `istante` con `Date.now()` senza
 * questa correzione vuol dire mostrare un conto alla rovescia sfasato di tutto
 * lo scarto — fermo a zero, o che non scende mai.
 *
 * ⚠️ Serve solo dove un istante del server viene CONFRONTATO con l'orologio
 * locale. Gli orologi di partita non passano di qui e fanno bene: loro
 * sottraggono solo delta locali a partire da un `lastSyncAt` preso alla
 * ricezione, e uno scarto costante non li tocca.
 */
export function conScartoServer(istante: number, serverTime: number): number {
  return Date.now() + (istante - serverTime);
}
